import { lazy } from 'react';

export const CatalogRootPageAsync = lazy(() => import('./CatalogRootPage'));
